<script lang="ts">
  import CTAButton, { type CTAButtonProps } from '../../../buttons/CTAButton.svelte';

  export type LoadingButtonProps = Omit<CTAButtonProps, 'onclick'> & {
    onclick?: () => Promise<unknown> | unknown;
  };

  let loading = $state(false);

  let { onclick, ...props }: LoadingButtonProps = $props();

  async function onLoadingClick() {
    if (!onclick) return;
    try {
      loading = true;
      await onclick();
    } finally {
      loading = false;
    }
  }
</script>

<CTAButton variant="primary" label="" {...props} {loading} onclick={onLoadingClick} />
